export const mutations = {
  MutationSetUserInAppSuggestionLoadingStatus(state, status) {
    state.userInAppSuggestionLoadingStatus = status;
  },
  MutationGetUserInAppSuggestion(state, _userInAppSuggestion) {
    state.userInAppSuggestion = _userInAppSuggestion;
  },
  MutationSetInAppTutorial(state, status) {
    state.userInAppTutorial = status;
  },
  MutationSetInAppManualGuide(state, status) {
    state.userInAppManualGuide = status;
  },
  MutationSetShouldShowInAppManualGuide(state, status) {
    state.shouldShowInAppManualGuide = status;
  },
  MutationSetOnScreenFirstLoad(state, status) {
    state.onScreenFirstLoad = status;
  },
  MutationSetInAppTourDocumentTour(state, userInAppTourDocumentTour) {
    state.userInAppTourDocumentTour = userInAppTourDocumentTour;
  },
  MutationSetInAppPeakExpSettings(state, userInAppPeakExpSettings) {
    state.userInAppPeakExpSettings = userInAppPeakExpSettings;
  },
};
